export var anchorType = /*#__PURE__*/function (anchorType) {
  anchorType["CENTER"] = "center";
  anchorType["TOP"] = "top";
  anchorType["TOP-LEFT"] = "top-left";
  anchorType["TOP-RIGHT"] = "top-right";
  anchorType["BOTTOM"] = "bottom";
  anchorType["BOTTOM-LEFT"] = "bottom-left";
  anchorType["BOTTOM-RIGHT"] = "bottom-right";
  anchorType["LEFT"] = "left";
  anchorType["RIGHT"] = "right";
  return anchorType;
}({});
export var anchorTranslate = {
  center: 'translate(-50%,-50%)',
  top: 'translate(-50%,0)',
  'top-left': 'translate(0,0)',
  'top-right': 'translate(-100%,0)',
  bottom: 'translate(-50%,-100%)',
  'bottom-left': 'translate(0,-100%)',
  'bottom-right': 'translate(-100%,-100%)',
  left: 'translate(0,-50%)',
  right: 'translate(-100%,-50%)'
};
export function applyAnchorClass(element, anchor, prefix) {
  var classList = element.classList;
  for (var _key in anchorTranslate) {
    if (anchorTranslate.hasOwnProperty(_key)) {
      classList.remove("l7-".concat(prefix, "-anchor-").concat(_key));
    }
  }
  classList.add("l7-".concat(prefix, "-anchor-").concat(anchor));
}